<template>
  <PageContainer title="Histórico de Baixas Manuais">
    <Box class="filtros-container" space="medium">
      <div class="filtros-row">
        <Select class="input-full" :options="autoescolasOptions" legend="Autoescola" placeholder="Selecione"
          :modelValue="filtros.autoescola" @update:modelValue="$event => (this.filtros.autoescola = $event)"/>
        <Input class="input-full" legend="Aluno(a)" placeholder="Digite o nome do aluno(a)" :modelValue="filtros.aluno"
            @update:modelValue="$event => (this.filtros.aluno = $event)" />
        <Period legend="Data da Baixa" :firstModelValue="filtros.dataInicio" :secondModelValue="filtros.dataFim"
          @update:firstModelValue="val => filtros.dataInicio = val"
          @update:secondModelValue="val => filtros.dataFim = val" />
        <Button text="Filtrar" color="primary" @handle:click="buscarBaixas" />
      </div>
    </Box>

    <Box class="tabela-container" space="medium">
      <Table :headers="headers">
        <tr v-for="baixa in baixas" :key="baixa.id">
          <td>{{ baixa.autoescola }}</td>
          <td>{{ baixa.aluno }}</td>
          <td>{{ baixa.cpf }}</td>
          <td>{{ baixa.valor }}</td>
          <td>{{ formatarData(baixa.data_baixa) }}</td>
          <td>{{ baixa.usuario }}</td>
          <td>
            <Button text="Visualizar Baixa" color="secondary" @handle:click="abrirModal(baixa)" />
          </td>
        </tr>
      </Table>
      <div v-if="baixas.length === 0" class="sem-resultados">Nenhuma baixa manual encontrada.</div>
    </Box>

    <VisualizarBaixaManualModal ref="modalVisualizar" :baixa="baixaSelecionada" />
  </PageContainer>
</template>

<script>
import PageContainer from 'core/PageContainer'
import Box from 'core/Box'
import Table from 'core/Table'
import Select from 'core/Select'
import Input from 'core/Input'
import Period from 'core/Period'
import Button from 'core/Button'
import VisualizarBaixaManualModal from './VisualizarBaixaManualModal.vue'

export default {
  name: 'HistoricoBaixaManual',
  components: {
    PageContainer,
    Box,
    Table,
    Select,
    Input,
    Period,
    Button,
    VisualizarBaixaManualModal,
  },
  data() {
    return {
      filtros: {
        autoescola: '',
        aluno: '',
        dataInicio: '',
        dataFim: '',
      },
      autoescolasOptions: [],
      baixas: [],
      headers: [
        'Autoescola',
        'Aluno',
        'CPF',
        'Valor',
        'Data/Hora Baixa',
        'Usuário',
        'Ações',
      ],
      baixaSelecionada: null,
    }
  },
  async created() {
    await this.carregarAutoescolas()
    await this.buscarBaixas()
  },
  methods: {
    async carregarAutoescolas() {
      try {
        const res = await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/autoescola/todas`)
        this.autoescolasOptions = (res.body.dados || []).map(cfc => ({ 
          value: cfc.tenant_schema,
          text: cfc.nome_fantasia 
        }))
      } catch (error) {
        console.error('Erro ao carregar autoescolas:', error)
        this.$toasted.show('Erro ao carregar lista de autoescolas.', {
          position: 'top-right',
        })
      }
    },
    async buscarBaixas() {
      try {
        const params = {
          autoescola: this.filtros.autoescola,
          aluno: this.filtros.aluno,
          dataInicio: this.filtros.dataInicio,
          dataFim: this.filtros.dataFim,
        }
        const res = await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/faturamento/consultar/baixa-manual`, { params })
        
        this.baixas = (res.body.data || []).map(item => ({
          id: item.id,
          fatura_id: item.fatura_id,
          autoescola: item.schema,
          aluno: item.aluno,
          cpf: item.cpf || '',
          valor: item.valor || '',
          data_baixa: item.data_operacao,
          usuario: item.usuario_email,
          motivo: item.motivo,
          boleto_original_base64: item.arquivo_boleto,
          comprovante_pagamento_base64: item.arquivo_comprovante,
        }))
        
      } catch (error) {
        console.error('Erro ao buscar baixas manuais:', error)
        this.baixas = []
        this.$toasted.show('Erro ao carregar histórico de baixas manuais.', {
          position: 'top-right',
        })
      }
    },
    abrirModal(baixa) {
      this.baixaSelecionada = baixa
      this.$refs.modalVisualizar.open()
    },
    formatarData(data) {
      if (!data) return ''
      return new Date(data).toLocaleString('pt-BR')
    },
  },
}
</script>

<style lang="scss" scoped>
.filtros-container {
  margin-bottom: 1.5rem;
}
.filtros-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  align-items: flex-end;
}
.input-full {
  flex: 1;
}
.tabela-container {
  margin-top: 1.5rem;
}
.sem-resultados {
  text-align: center;
  color: #888;
  margin-top: 2rem;
}
.motivo-resumido {
  cursor: help;
  color: #1C2D5A;
}
</style>
